import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { Cookie } from '@mui/icons-material';

const ConsentBanner = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if consent has been given
        const consent = localStorage.getItem('ga_consent');
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('ga_consent', 'granted');
        localStorage.setItem('ga_consent_date', new Date().toISOString());
        setShowBanner(false);
        
        // Initialize gtag if not already initialized
        if (!window.gtag && window.dataLayer) {
            window.gtag = function() {
                window.dataLayer.push(arguments);
            };
        }
        
        // Update consent mode
        if (window.gtag) {
            window.gtag('consent', 'update', {
                'analytics_storage': 'granted',
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
        }
        
        // Load Google Analytics if conditions are met
        loadGoogleAnalytics();
    };

    const handleReject = () => {
        localStorage.setItem('ga_consent', 'denied');
        localStorage.setItem('ga_consent_date', new Date().toISOString());
        setShowBanner(false);
        
        // Initialize gtag if not already initialized
        if (!window.gtag && window.dataLayer) {
            window.gtag = function() {
                window.dataLayer.push(arguments);
            };
        }
        
        // Update consent mode to denied
        if (window.gtag) {
            window.gtag('consent', 'update', {
                'analytics_storage': 'denied',
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            });
        }
    };

    const loadGoogleAnalytics = () => {
        // Only load if conditions are met and consent is granted
        if (window.location.protocol === 'https:' && 
            window.location.hostname === 'portal.xtract2ai.com' &&
            localStorage.getItem('ga_consent') === 'granted') {
            
            // Ensure dataLayer and gtag are initialized (should already be from index.html)
            if (!window.dataLayer) {
                window.dataLayer = [];
            }
            if (!window.gtag) {
                window.gtag = function() {
                    window.dataLayer.push(arguments);
                };
            }
            
            // Load gtag.js script if not already loaded
            if (!document.querySelector('script[src*="googletagmanager/gtag/js"]')) {
                const script = document.createElement('script');
                script.async = true;
                script.src = 'https://www.googletagmanager.com/gtag/js?id=G-YSK74EYY1Z';
                document.head.appendChild(script);
                
                // Wait for script to load before configuring
                script.onload = () => {
                    if (window.gtag) {
                        window.gtag('js', new Date());
                        window.gtag('config', 'G-YSK74EYY1Z', {
                            'anonymize_ip': true
                        });
                    }
                };
            } else {
                // Script already loaded, just configure
                if (window.gtag) {
                    window.gtag('js', new Date());
                    window.gtag('config', 'G-YSK74EYY1Z', {
                        'anonymize_ip': true
                    });
                }
            }
        }
    };

    if (!showBanner) {
        return null;
    }

    return (
        <Paper
            elevation={8}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 10000,
                p: 5,
               
                borderTop: '2px solid #4C43A3',
            }}
        >
            <Box
                sx={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}
            >
                <Cookie sx={{ color: '#4C43A3', fontSize: '2rem' }} />
                <Box sx={{ flex: 1 }}>
                    <Typography variant="h5" fontWeight={400} mb={1}>
                        Cookie Consent
                    </Typography>
                    <Typography variant="body1" color="text.primary">
                        We use cookies to enhance your experience and analyze usage. By continuing to use this site, you agree to our use of cookies.
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                    <Button
                        variant="outlined"
                        onClick={handleReject}
                        sx={{
                            borderColor: '#4C43A3',
                            color: '#4C43A3',
                            '&:hover': {
                                borderColor: '#4C43A3',
                                backgroundColor: 'rgba(76, 67, 163, 0.04)',
                            },
                        }}
                    >
                        Reject
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleAccept}
                        sx={{
                            backgroundColor: '#4C43A3',
                            '&:hover': {
                                backgroundColor: '#3a3480',
                            },
                        }}
                    >
                        Accept All
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
};

export default ConsentBanner;

